export class LiquiditySourceConfigDto {
  sources?: {
    include?: {
      [sourceIdentifier: string]: {
        subSources?: {
          [subSourceIdentifier: string]: Record<string, never>;
        };
      };
    };
  };
}
